// extracted by mini-css-extract-plugin
module.exports = {"small":"576px","medium":"768px","large":"992px","xLarge":"1200px","huge":"1400px","room":"Room_room__1-ytN","modal":"Room_modal__nU0Xa","iconButton":"Room_iconButton__3bdkO"};